<template>
    <svg viewBox="0 0 70 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_16605_236813)">
            <path
                d="M62.085 11.9832L68.0806 1.3332H61.9613L58.7723 6.7332L55.3414 1.3332H48.6371L55.707 11.9712L48.6371 23.9712H55.3414L59.166 17.1492L63.6992 23.9712H69.6836L62.085 11.9832ZM39.9137 1.3332L35.3636 13.4472L31.0497 1.3332H25.6109L22 24.0012H27.4951L29.2724 10.9392H29.3286L34.1993 24.0012H36.3985L41.4998 10.9392H41.5673L43.114 24.0012H48.6371L45.42 1.3332H39.9137ZM11.9042 11.3592V15.9672H16.4038C16.1675 18.5532 14.334 19.8792 11.9605 19.8792C8.34963 19.8792 6.39797 16.3332 6.39797 12.8292C6.39797 9.3252 8.27089 5.7192 11.8761 5.7192C14.0921 5.7192 15.6782 7.1472 16.4375 9.2892L21.6457 6.9612C19.829 2.7612 16.4656 0.679199 12.1236 0.679199C5.32371 0.679199 0.683594 5.4792 0.683594 12.7932C0.683594 19.8792 5.29559 24.6792 11.9324 24.6792C15.4589 24.6792 18.5691 23.3352 20.6277 20.2632C22.4781 17.4792 22.7312 14.6472 22.7874 11.3592H11.9042Z"
                fill="#1C449B"
            />
        </g>
        <defs>
            <clipPath id="clip0_16605_236813">
                <rect width="70" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
